import { connect } from 'react-redux';
import ReportBalanceHistoryComponent from './balance-history.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {
		intl: null,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportBalanceHistoryComponent);



// WEBPACK FOOTER //
// ./src/components/report/balance-history/balance-history.ts